var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"side-effects"},[_c('OnlineOffline'),_vm._v(" "),_c('OrderDetail'),_vm._v(" "),_c('Interrupt361'),_vm._v(" "),_c('SideStockTrade'),_vm._v(" "),_c('SideStockView')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }